import { render } from "./ChangeLogCard.vue?vue&type=template&id=5d72fa4c"
import script from "./ChangeLogCard.vue?vue&type=script&lang=ts"
export * from "./ChangeLogCard.vue?vue&type=script&lang=ts"
script.render = render

export default script